import React from 'react'
import { t } from 'i18next'
import { inject, observer } from 'mobx-react'
import { Col, Form, Row } from 'react-bootstrap'
import { StyledFormHeadline, StyledValidationMessage } from './RegistrationStyles'
import ArraySelect from '../Select/ArraySelect'
import ZipSuggestion from '../Forms/ZipSuggestion'
import { getFakeEvent } from '../../utils/utils'

const OfficeAddressData = inject('registrationStore', 'uiStore')(observer((props) => {
  const { registrationStore, registrationConfig } = props
  const additionalData = registrationStore.registrationData.additionalData
  return (
    <>
      <StyledFormHeadline>{registrationConfig.officeAddressData.headline}</StyledFormHeadline>
      <Row>
        <Form.Group className="mb-3" as={Col} controlId="formStreet">
          <Form.Label>{t('formularFields:street')} *</Form.Label>
          <Form.Control
            value={additionalData.address.street}
            type="text"
            placeholder={t('formularFields:street')}
            name="additionalData.address.street"
            onChange={registrationStore.handleChange2}
            isInvalid={registrationStore.formErrors.additionalDataaddressstreet}
          />
          <StyledValidationMessage type="invalid">
            {registrationStore.formErrors.additionalDataaddressstreet}
          </StyledValidationMessage>
        </Form.Group>
        <Form.Group className="mb-3" as={Col} md="4" controlId="formStreetNr">
          <Form.Label>{t('formularFields:housenumber')} *</Form.Label>
          <Form.Control
            value={additionalData.address.streetNumber}
            type="text"
            placeholder={t('formularFields:housenumber')}
            name="additionalData.address.streetNumber"
            onChange={registrationStore.handleChange2}
            isInvalid={registrationStore.formErrors.additionalDataaddressstreetNumber}
          />
          <StyledValidationMessage type="invalid">
            {registrationStore.formErrors.additionalDataaddressstreetNumber}
          </StyledValidationMessage>
        </Form.Group>
      </Row>
      <Row>
        <Form.Group className="mb-3" as={Col} md="4" controlId="formZip">
          <Form.Label>{t('formularFields:zip')} *</Form.Label>
          <ZipSuggestion
            type="text"
            placeholder={t('EmployeeFormAddress:postcode')}
            name="additionalData.address.zIP"
            onChange={registrationStore.handleChange2}
            value={additionalData.address.zIP}
            onChangeSuggestion={obj => registrationStore.handleChange2(getFakeEvent("additionalData.address.town", obj.cityName, "text"))}
            countryIsoCode={additionalData.address.country.isoCode || "de"}
            isInvalid={registrationStore.formErrors.additionalDataaddresszIP}
          >
            <StyledValidationMessage type="invalid" >
              {registrationStore.formErrors.additionalDataaddresszIP}
            </StyledValidationMessage>
          </ZipSuggestion>
        </Form.Group>
        <Form.Group className="mb-3" as={Col} controlId="formCity">
          <Form.Label>{t('formularFields:city')} *</Form.Label>
          <Form.Control
            value={additionalData.address.town}
            type="text"
            placeholder={t('formularFields:city')}
            name="additionalData.address.town"
            onChange={registrationStore.handleChange2}
            isInvalid={registrationStore.formErrors.additionalDataaddresstown}
          />
          <StyledValidationMessage type="invalid">
            {registrationStore.formErrors.additionalDataaddresstown}
          </StyledValidationMessage>
        </Form.Group>
      </Row>
      <Form.Group className="mb-3" controlId="formCountry">
        <Form.Label>{t('formularFields:country')} *</Form.Label>
        <ArraySelect
          label={`${t('formularFields:country')}* `}
          options={registrationStore.countries}
          value={additionalData.address.country.id || ""}
          onChange={registrationStore.handleChangeOfficeAddressCountry}
          isInvalid={registrationStore.formErrors.additionalDataaddresscountryid}
          defaultOption={{ value: "", name: t('pleaseSelect') }}
        />
        <StyledValidationMessage type="invalid">
          {registrationStore.formErrors.additionalDataaddresscountryid}
        </StyledValidationMessage>
      </Form.Group>
    </>
  )
}))

export default OfficeAddressData